import { createContext } from "react";

import {
  attachInstruction,
  extractInstruction,
} from "@atlaskit/pragmatic-drag-and-drop-hitbox/tree-item";
import { DropIndicator } from "@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/box";

import type { TreeAction, TreeItem } from "../data/tree";
import DropIndicatorCustom from "./dropIndicatorCustom";
import DropIndicatorIconCustom from "./iconPage/dropIndicatorPageCustom";
import DropIndicatorPageCustom from "./iconPage/dropIndicatorPageCustom";

export type TreeContextValue = {
  dispatch: (action: TreeAction) => void;
  uniqueContextId: Symbol;
  getPathToItem: (itemId: string) => string[];
  getMoveTargets: ({ itemId }: { itemId: string }) => TreeItem[];
  getChildrenOfItem: (itemId: string) => TreeItem[];
  registerTreeItem: (args: {
    itemId: string;
    element: HTMLElement;
    actionMenuTrigger: HTMLElement;
  }) => void;
  getParentsMoveTargets: ({ itemId }: { itemId: string }) => TreeItem[];
};

export const TreeContext = createContext<TreeContextValue>({
  dispatch: () => {},
  uniqueContextId: Symbol("uniqueId"),
  getPathToItem: () => [],
  getMoveTargets: () => [],
  getChildrenOfItem: () => [],
  registerTreeItem: () => {},
  getParentsMoveTargets: () => [],
});

export type DependencyContext = {
  DropIndicator: typeof DropIndicatorCustom; // Para TreeItem
  DropIndicatorPage: typeof DropIndicatorPageCustom; // Para IconPage
  attachInstruction: typeof attachInstruction;
  extractInstruction: typeof extractInstruction;
};

export const DependencyContext = createContext<DependencyContext>({
  DropIndicator: DropIndicatorCustom,
  DropIndicatorPage: DropIndicatorPageCustom,
  attachInstruction,
  extractInstruction,
});
